import { styled, css } from '@mui/material/styles';
import MUIMenu from '@mui/material/Menu';
import MUIMenuItem from '@mui/material/MenuItem';
import shadows from '../../theme/shadows';

export const Menu = styled(MUIMenu)(
  () => css`
    .MuiMenu-paper {
      box-shadow: ${shadows.shadowBrown};
    }

    .MuiMenu-list {
      padding: 0.4rem 0;
    }
  `
);

export const MenuItem = styled(MUIMenuItem)(
  () => css`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    min-height: 3.6rem;
    padding: 0.8rem 1.2rem;

    & + .MuiDivider-root {
      margin-top: 0;
      margin-bottom: 0;
    }
  `
);
